import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import cx from 'classnames';
import React from 'react';
import Icons from '../assets/icons/icons.json';
var Icon = React.forwardRef(function (_ref, ref) {
  var icon = _ref.icon,
      additionalIcons = _ref.additionalIcons,
      fallback = _ref.fallback,
      className = _ref.className,
      size = _ref.size,
      opts = _objectWithoutPropertiesLoose(_ref, ["icon", "additionalIcons", "fallback", "className", "size"]);

  var getIcon = function getIcon() {
    var classes = cx('icon', className, {
      'icon--small': size === 'small',
      'icon--large': size === 'large',
      'icon--xlarge': size === 'xlarge'
    }); // Merge in base icons with anything additional

    var iconSource = Object.assign(Icons, additionalIcons); // Match on fallback prop if supplied

    var matchedIcon = iconSource[icon] || iconSource[fallback]; // If we find an icon

    if (matchedIcon) {
      return React.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: classes,
        ref: ref
      }, opts, {
        dangerouslySetInnerHTML: {
          __html: matchedIcon
        } // eslint-disable-line react/no-danger

      }));
    }

    console.error('Icon not found'); // eslint-disable-line no-console

    return false;
  };

  return getIcon();
});
export default Icon;